import styles from './ChangeTarif.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import SelectUnit, {SelectUnitDataInt, SelectUnitRefInt} from "../../../FormTemplate/SelectUnit/SelectUnit";
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate, {IRefMainFormTemplate} from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ButtonContainer from "../../../FormTemplate/ButtonContainer/ButtonContainer";
interface IChangeTarifProps
{
    orderId:string
    onClose: ()=>void
}
export default function ChangeTarif({orderId, onClose}:IChangeTarifProps)
{
    const dataOperList = useRef()
    const [ldrOperList,rsOperList,exOperList] = useApiQuery("/ref/oper","get",dataOperList);

    const dataTarifList = useRef<{
        regionId:number
    }>()
    const [ldrTarifList,rsTarifList,exTarifList] = useApiQuery("/tarif/list","post",dataTarifList);
    const [tarifList, setTarifList] = useState<any[]>([])

    const dataTarifChange = useRef<{
        orderId:string
        tarifId:string
    }>()
    const [ldrDataTarifChange,rsDataTarifChange,exDataTarifChange] = useApiQuery("/sell/sim/order/tarif/change","post",dataTarifChange);

    const refOper = useRef<SelectUnitRefInt>(null)
    const refTarif = useRef<SelectUnitRefInt>(null)
    const refMain = useRef<IRefMainFormTemplate>(null)



    const [suTariffList , setSuTarifList] = useState<SelectUnitDataInt[]>([])
    const [suOperList, setSuOperList] = useState<SelectUnitDataInt[]>([])

    const [operId, setOperId] = useState()


    useEffect(()=>{
        loadOperList()
    },[dataOperList])
    useEffect(()=>{
        loadTarifList()
    },[dataTarifList])


    useEffect(()=>{
        if(!operId)setSuTarifList([])

        const px = tarifList?.filter((item)=>item?.operId === operId)

        const x:SelectUnitDataInt[] = px?.map((item)=>{
            const name = `${item?.name} -> АП: ${item?.apList[0]?.val} Пакет: ${item?.packetList[0]?.val} Интернет: ${item?.netList[0]?.val}`
            return{
                val: item?.tarifId,
                name: name
            }

        })

        setSuTarifList(x)
    },[tarifList,operId])

    const loadTarifList = ()=>{
        dataTarifList.current = {
            regionId:0
        }
        exTarifList().then((e)=>{
            if(e?.success)
            {
                setTarifList(e?.payload)
            }
        })
    }
    const loadOperList = () =>{
        exOperList().then((e)=>{
            if(e?.success )
            {
                setSuOperList(e?.payload?.map((item:any)=>{
                    return {
                        name: item?.name,
                        val: item?.operId
                    }
                }))
                return
            }
        })
    }


    const handleChange = ()=>{
        if(!refTarif.current)return
        const tarif =refTarif.current.getValue()
        if(tarif.length ===0 )
        {
            if(refMain.current)refMain.current.state("Не выбран тариф", true, 4000)
            return;
        }
        dataTarifChange.current={
            orderId: orderId,
            tarifId: tarif[0]
        }
        exDataTarifChange().then((e)=>{
            if(e?.success)
            {
                if(refMain.current)refMain.current.state("Тариф сменен", false, 4000)
                return
            }
            if(refMain.current)refMain.current.state(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true, 4000)
        })

    }

    return (
        <ModalWindow cssClass={styles.mdMain}>
            <div className={styles.mfCont}>
                <MainFormTemplate title={`Смена тарифа для заказа ${orderId}`} maxWidth={"100%"} background={"white"} ref={refMain} >
                    <div className={"row"}>
                        <div className={"d-flex col-md-4 align-items-center justify-content-start"}>
                            <SelectUnit
                                inData={suOperList}
                                capt={"Оператор"}
                                getVal={(e)=>setOperId(e[0])}
                                ref={refOper}
                            />
                        </div>
                        <div className={"d-flex col-md-8 align-items-center justify-content-start"}>
                            <SelectUnit
                                inData={suTariffList}
                                capt={"Тариф"}
                                enabled={suTariffList?.length > 0}
                                ref={refTarif}
                            />
                        </div>
                    </div>

                    <ButtonContainer resize={true} my={20}>
                        <button type="button" className="btn btn-secondary "
                                onClick={()=>handleChange()}
                        >Сменить</button>

                        <button type="button" className="btn btn-secondary "
                                onClick={()=>onClose()}
                        >Отмена</button>

                    </ButtonContainer>
                </MainFormTemplate>

            </div>
        </ModalWindow>
    )
}